







import Vue from 'vue';
import { EAnchor } from '@/common/enums/anchor.enum';

export default Vue.extend({
  name: `Anchor`,
  data() {
    return {
      hash: window.location.hash,
    };
  },
  props: {
    identifier: {
      required: true,
      validator: (val: EAnchor) => Object.values(EAnchor).includes(val),
    },
    onload: {
      default: false,
      type: Boolean,
    },
  },
  mounted() {
    if(this.onload && this.hash && this.hash.includes(`#${this.identifier}`)) {
      const anchor = document.getElementById(this.identifier);
      if(anchor) {
        anchor.scrollIntoView(true);
      }
    }
  },
});
